export default () => {
  const role = localStorage.getItem('escenaRole');
  const isFreePlan = localStorage.getItem('escenaPlan') === 'free';
  return isFreePlan || !role;
};



// WEBPACK FOOTER //
// ./src/utils/IsGuest.js